import Page from "./page";

export default function DefalutLayout() {
    return (
        <div>
            <Page />
        </div>
    )
}